// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__1uc-B","pageLink":"pagination_pageLink__3EfKE","activeLink":"pagination_activeLink__3O0EY"};